import React from 'react';
import {
  Box,
  Button,
  Checkbox,
  Link,
  Flex,
  Label,
  theme,
} from '@xometry/xometry_loft';
import { Formik, FieldArray } from 'formik';
import { css } from '@emotion/react';
import { capabilitiesSchema } from '../../../../utils/validations';
import TooltipBlueIcon from '../../../../components/TooltipBlueIcon';

const SupplierCapabilitiesForm = (props: any) => {
  const { values, handleSubmit, processes } = props;

  const formLabel = css`
    font-family: ${theme.fonts[0]};
    font-style: normal;
    color: ${theme.colors.darkBlues[75]};
    font-weight: ${theme.fontWeights.regular};
    font-size: ${theme.fontSizes[2]};
    lineHeight=${theme.lineHeights[2]}
  `;

  return (
    <form onSubmit={handleSubmit}>
      <Box padding="0px 0px 0px 45px">
        <FieldArray
          name="supported_processes"
          render={(arrayHelpers) => (
            <Flex marginTop="10px" flexDirection="column">
              <Flex marginTop="13px">
                <Label
                  htmlFor="cncSheet"
                  fontWeight={theme.fontWeights.semibold}
                >
                  CNC/Sheet
                </Label>
                <TooltipBlueIcon minWidth="187px">
                  <Box color={theme.colors.darkBlues[90]}>
                    <Box>
                      View our{' '}
                      <Link
                        href="https://community.xometry.com/kb/articles/541-machining-guide"
                        target="_blank"
                      >
                        machine guide for
                      </Link>{' '}
                    </Box>
                    <Box>more information</Box>
                  </Box>
                </TooltipBlueIcon>
              </Flex>
              {processes.subtractive.map((proc) => (
                <div key={proc.initialism}>
                  <Checkbox
                    id={`proc-${proc.initialism}`}
                    name="supported_processes"
                    type="checkbox"
                    value={proc._id}
                    checked={values.supported_processes.includes(proc._id)}
                    onChange={(e) => {
                      if (e.target.checked) arrayHelpers.push(proc._id);
                      else
                        arrayHelpers.remove(
                          values.supported_processes.indexOf(proc._id)
                        );
                    }}
                  />{' '}
                  <label htmlFor={`proc-${proc.initialism}`} css={formLabel}>
                    {proc.web_name}
                  </label>
                </div>
              ))}

              <Flex marginTop="13px">
                <Label
                  htmlFor="injectionMolding"
                  fontWeight={theme.fontWeights.semibold}
                >
                  {' '}
                  Injection Molding/Casting
                </Label>
                <TooltipBlueIcon minWidth="256px">
                  <Box color={theme.colors.darkBlues[90]}>
                    <Box>Molding and casting Partners must be</Box>
                    <Box>able to meet certain requirements. View</Box>
                    <Box>
                      our molding Guide for more information
                      {/* <Link
                        href="https://community.xometry.com/kb/injection-molding-guide"
                        target="_blank"
                      >
                        molding Guide
                      </Link>{" "}
                      for more information */}
                    </Box>
                  </Box>
                </TooltipBlueIcon>
              </Flex>
              {processes.molding.map((proc) => (
                <div key={proc.initialism}>
                  <Checkbox
                    id={`proc-${proc.initialism}`}
                    name="supported_processes"
                    type="checkbox"
                    value={proc._id}
                    checked={values.supported_processes.includes(proc._id)}
                    onChange={(e) => {
                      if (e.target.checked) arrayHelpers.push(proc._id);
                      else
                        arrayHelpers.remove(
                          values.supported_processes.indexOf(proc._id)
                        );
                    }}
                  />{' '}
                  <label htmlFor={`proc-${proc.initialism}`} css={formLabel}>
                    {proc.web_name}
                  </label>
                </div>
              ))}

              <Flex marginTop="13px">
                <Label
                  htmlFor="printing"
                  fontWeight={theme.fontWeights.semibold}
                >
                  3D Printing
                </Label>
                <TooltipBlueIcon minWidth="256px">
                  <Box color={theme.colors.darkBlues[90]}>
                    <Box>Currently, we are only actively searching</Box>
                    <Box>for DMSL and FDM Partners. View our</Box>
                    <Box>
                      <Link
                        href="https://community.xometry.com/kb/articles/539-additive-guide"
                        target="_blank"
                      >
                        Additive Guide
                      </Link>{' '}
                      for more information
                    </Box>
                  </Box>
                </TooltipBlueIcon>
              </Flex>
              {processes.additive.map((proc) => (
                <div key={proc.initialism}>
                  <Checkbox
                    id={`proc-${proc.initialism}`}
                    name="supported_processes"
                    type="checkbox"
                    value={proc._id}
                    checked={values.supported_processes.includes(proc._id)}
                    onChange={(e) => {
                      if (e.target.checked) arrayHelpers.push(proc._id);
                      else
                        arrayHelpers.remove(
                          values.supported_processes.indexOf(proc._id)
                        );
                    }}
                  />{' '}
                  <label htmlFor={`proc-${proc.initialism}`} css={formLabel}>
                    {proc.web_name}
                  </label>
                </div>
              ))}
            </Flex>
          )}
        />
        <Box textAlign="center">
          <Button
            type="submit"
            scale="large"
            kind="primary"
            margin="auto"
            marginTop="24px"
          >
            Submit
          </Button>
        </Box>
      </Box>
    </form>
  );
};

const SupplierCapabilitiesFormWrapper = (props) => {
  const { initialValues, onSubmit, processes } = props;
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={capabilitiesSchema}
    >
      {(formikProps) => (
        <SupplierCapabilitiesForm {...formikProps} processes={processes} />
      )}
    </Formik>
  );
};
export default SupplierCapabilitiesFormWrapper;
